/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CommunitySpecificProgramOptions,
  CommunitySpecificProgramOptionsFromJSON,
  Program,
  ProgramCreate,
  ProgramCreateToJSON,
  ProgramFromJSON,
  ProgramInviteFamilyOptionsResponse,
  ProgramInviteFamilyOptionsResponseFromJSON,
  ProgramOptions,
  ProgramOptionsFromJSON,
  Programs,
  ProgramsFromJSON,
  ProgramStudentsResponse,
  ProgramStudentsResponseFromJSON,
  ProgramUpdate,
  ProgramUpdateToJSON,
  StudentTutorAssignmentRequestBody,
  StudentTutorAssignmentRequestBodyToJSON,
} from '../models'
import * as runtime from '../runtime'

export interface CreateProgramRequest extends runtime.BaseRequestParameters {
  body?: ProgramCreate
}

export interface FetchAllProgramsRequest extends runtime.BaseRequestParameters {
  communityId?: number
  academicYearBeginning?: number
}

export interface FetchCommunitySpecificProgramOptionsRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
}

export interface FetchInviteFamilyProgramsRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
}

export interface FetchProgramRequest extends runtime.BaseRequestParameters {
  programId: number
}

export interface FetchStudentsRequest extends runtime.BaseRequestParameters {
  programId: number
}

export interface UpdateProgramRequest extends runtime.BaseRequestParameters {
  body?: ProgramUpdate
}

export interface UpdateStudentTutorAssignmentsRequest
  extends runtime.BaseRequestParameters {
  programId: number
  body?: StudentTutorAssignmentRequestBody
}

/**
 *
 */
export class ProgramsApi extends runtime.BaseAPI {
  /**
   *  Create a new Program within a community.  - The specified community must be viewable to the requester. - The specified director must:   - possess Program/view, Program/edit, and Program/direct<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified community\'s manager.   - be able to direct a program with the specified Program Type, determined by the director\'s Program/direct<ProgramType> grant. For example, a director with a Program/directFoundations grant can direct a program with the Foundations type. - The specified tutor must:   - possess Program/view and Program/tutor<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified program director.   - be able to tutor a program with the specified Program Type, determined by the tutor\'s Program/tutor<ProgramType> grant. For example, a director with a Program/tutorFoundations grant can tutor a program with the Foundations type.  ## PERMISSIONS: - Requester must possess a User/view, Community/view, Program/view, and Program/create grant, else a 403 will be returned. - User/view[their team\'s] grant allows the requester to assign possible directors and tutors that are within their downline team. - User/view[any] grant allows the requester to view any possible director or tutor, regardless of team. - Community/view[their team\'s] grant allows the requester to see communities that are within their downline team. - Community/view[any] grant allows the requester to see any community, regardless of team.   - Program/create[their team\'s] will still restrict program creation in only communities within the requester\'s team.
   * Create a new Program.
   */
  async createProgramRaw(
    requestParameters: CreateProgramRequest
  ): Promise<runtime.ApiResponse<Program>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: ProgramCreateToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProgramFromJSON(jsonValue)
    )
  }

  /**
   *  Create a new Program within a community.  - The specified community must be viewable to the requester. - The specified director must:   - possess Program/view, Program/edit, and Program/direct<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified community\'s manager.   - be able to direct a program with the specified Program Type, determined by the director\'s Program/direct<ProgramType> grant. For example, a director with a Program/directFoundations grant can direct a program with the Foundations type. - The specified tutor must:   - possess Program/view and Program/tutor<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified program director.   - be able to tutor a program with the specified Program Type, determined by the tutor\'s Program/tutor<ProgramType> grant. For example, a director with a Program/tutorFoundations grant can tutor a program with the Foundations type.  ## PERMISSIONS: - Requester must possess a User/view, Community/view, Program/view, and Program/create grant, else a 403 will be returned. - User/view[their team\'s] grant allows the requester to assign possible directors and tutors that are within their downline team. - User/view[any] grant allows the requester to view any possible director or tutor, regardless of team. - Community/view[their team\'s] grant allows the requester to see communities that are within their downline team. - Community/view[any] grant allows the requester to see any community, regardless of team.   - Program/create[their team\'s] will still restrict program creation in only communities within the requester\'s team.
   * Create a new Program.
   */
  async createProgram(
    requestParameters: CreateProgramRequest
  ): Promise<Program> {
    const response = await this.createProgramRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Lists programs the requester can view with filtering grouped by academic year.  PERMISSIONS: - Acting as a parent: The requester can always view the programs that they are \'in\'. Being in a program means that the user has an active enrollment in the program. - Program/view[their team\'s] allows the requester to view programs in their downline team where a member of their team actively directs or tutors a program. - Program/view[any] allows the requester to see all programs.
   * List of programs the requester can view with filtering grouped by academic year.
   */
  async fetchAllProgramsRaw(
    requestParameters: FetchAllProgramsRequest
  ): Promise<runtime.ApiResponse<Programs>> {
    const queryParameters: any = {}

    if (requestParameters.communityId !== undefined) {
      queryParameters['communityId'] = requestParameters.communityId
    }

    if (requestParameters.academicYearBeginning !== undefined) {
      queryParameters['academicYearBeginning'] =
        requestParameters.academicYearBeginning
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProgramsFromJSON(jsonValue)
    )
  }

  /**
   *  Lists programs the requester can view with filtering grouped by academic year.  PERMISSIONS: - Acting as a parent: The requester can always view the programs that they are \'in\'. Being in a program means that the user has an active enrollment in the program. - Program/view[their team\'s] allows the requester to view programs in their downline team where a member of their team actively directs or tutors a program. - Program/view[any] allows the requester to see all programs.
   * List of programs the requester can view with filtering grouped by academic year.
   */
  async fetchAllPrograms(
    requestParameters: FetchAllProgramsRequest
  ): Promise<Programs> {
    const response = await this.fetchAllProgramsRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Fetch possible program types, fees, default semester start dates, directors, and tutors that the requester can view for creating/editing a program.  This is the initial set of options provided when creating or editing a program.  - Returned directors will include any valid or pending actor that have a Program/view, Program/edit, and Program/direct<ProgramType> grant.   - A director should be allowed to be assigned to a program if they are or will be valid at the time the program starts.   - For each director option, an array of \'applicableToResourceKeys\' property will be returned. These represent the communityKeys for communities in which the director is related to. A director cannot be assigned to a program that is not one of the specified communities.   - For each director option, an array of \'applicableToResourceTypes\' property will be returned. These represent the types of programs that this director can be assigned to based on the director\'s Program/direct<ProgramType> grants. - Returned tutors will include any valid or pending actor that have a Program/view and Program/tutor<ProgramType> grant.   - A tutor should be allowed to be assigned to a program if they are or will be valid at any time the program is active.   - For each tutor option, an array of \'applicableToResourceKeys\' property will be returned. These represent the actorKeys for directors in the tutor\'s upline team. A tutor cannot be assigned to a program that does not have one of the specified directors as the assigned director for the program.   - For each tutor option, an array of \'applicableToResourceTypes\' property will be returned. These represent the types of programs that this tutor can be assigned to based on the tutor\'s Program/tutor<ProgramType> grants.
   * Fetch possible program types, fees, default semester start dates, directs, and tutors for creating/editing a program.
   */
  async fetchCommunitySpecificProgramOptionsRaw(
    requestParameters: FetchCommunitySpecificProgramOptionsRequest
  ): Promise<runtime.ApiResponse<CommunitySpecificProgramOptions>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchCommunitySpecificProgramOptions.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs/options/community/{communityKey}`.replace(
        `{${'communityKey'}}`,
        encodeURIComponent(String(requestParameters.communityKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CommunitySpecificProgramOptionsFromJSON(jsonValue)
    )
  }

  /**
   *  Fetch possible program types, fees, default semester start dates, directors, and tutors that the requester can view for creating/editing a program.  This is the initial set of options provided when creating or editing a program.  - Returned directors will include any valid or pending actor that have a Program/view, Program/edit, and Program/direct<ProgramType> grant.   - A director should be allowed to be assigned to a program if they are or will be valid at the time the program starts.   - For each director option, an array of \'applicableToResourceKeys\' property will be returned. These represent the communityKeys for communities in which the director is related to. A director cannot be assigned to a program that is not one of the specified communities.   - For each director option, an array of \'applicableToResourceTypes\' property will be returned. These represent the types of programs that this director can be assigned to based on the director\'s Program/direct<ProgramType> grants. - Returned tutors will include any valid or pending actor that have a Program/view and Program/tutor<ProgramType> grant.   - A tutor should be allowed to be assigned to a program if they are or will be valid at any time the program is active.   - For each tutor option, an array of \'applicableToResourceKeys\' property will be returned. These represent the actorKeys for directors in the tutor\'s upline team. A tutor cannot be assigned to a program that does not have one of the specified directors as the assigned director for the program.   - For each tutor option, an array of \'applicableToResourceTypes\' property will be returned. These represent the types of programs that this tutor can be assigned to based on the tutor\'s Program/tutor<ProgramType> grants.
   * Fetch possible program types, fees, default semester start dates, directs, and tutors for creating/editing a program.
   */
  async fetchCommunitySpecificProgramOptions(
    requestParameters: FetchCommunitySpecificProgramOptionsRequest
  ): Promise<CommunitySpecificProgramOptions> {
    const response = await this.fetchCommunitySpecificProgramOptionsRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Returns all the programs within a user\'s downline for the communityKey passed.
   */
  async fetchInviteFamilyProgramsRaw(
    requestParameters: FetchInviteFamilyProgramsRequest
  ): Promise<runtime.ApiResponse<ProgramInviteFamilyOptionsResponse>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchInviteFamilyPrograms.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/invite/programs/{communityKey}`.replace(
        `{${'communityKey'}}`,
        encodeURIComponent(String(requestParameters.communityKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProgramInviteFamilyOptionsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Returns all the programs within a user\'s downline for the communityKey passed.
   */
  async fetchInviteFamilyPrograms(
    requestParameters: FetchInviteFamilyProgramsRequest
  ): Promise<ProgramInviteFamilyOptionsResponse> {
    const response = await this.fetchInviteFamilyProgramsRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Fetch an existing program\'s details. The requester must be able to view the specified program in order to fetch its details. Permissions the user can exercise with regard to this specific community are provided in `meta.permissions` and should be used instead of those provided at login when deciding available actions the user can take against this community (e.g. Edit).  ## PERMISSIONS TO FETCH A PROGRAM: - When the requester is acting as a parent, they will only be able to view programs that they have a student actively enrolled in. - **Program/view[their team\'s]** grant allows the requester to view the details of a program where a member of the requester\'s downline team actively directs or tutors the program. - **Program/view[any]** grant allows the requester to see the details of any program, regardless of their team hierarchy.  ## PERMISSIONS RETURNED IN META.PERMISSIONS: - Program/parentRestrictedView allows viewing all program details EXCEPT:   - Sub-licensed Fee Percentage.   - View Invoice button on the students table.   - Drop button on the students table. - **Program/view** allows viewing all program details, including the excluded details above for parentRestrictedView. - **Program/edit** allows viewing the edit program button.
   * Fetch an existing program.
   */
  async fetchProgramRaw(
    requestParameters: FetchProgramRequest
  ): Promise<runtime.ApiResponse<Program>> {
    if (
      requestParameters.programId === null ||
      requestParameters.programId === undefined
    ) {
      throw new runtime.RequiredError(
        'programId',
        'Required parameter requestParameters.programId was null or undefined when calling fetchProgram.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(requestParameters.programId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProgramFromJSON(jsonValue)
    )
  }

  /**
   *  Fetch an existing program\'s details. The requester must be able to view the specified program in order to fetch its details. Permissions the user can exercise with regard to this specific community are provided in `meta.permissions` and should be used instead of those provided at login when deciding available actions the user can take against this community (e.g. Edit).  ## PERMISSIONS TO FETCH A PROGRAM: - When the requester is acting as a parent, they will only be able to view programs that they have a student actively enrolled in. - **Program/view[their team\'s]** grant allows the requester to view the details of a program where a member of the requester\'s downline team actively directs or tutors the program. - **Program/view[any]** grant allows the requester to see the details of any program, regardless of their team hierarchy.  ## PERMISSIONS RETURNED IN META.PERMISSIONS: - Program/parentRestrictedView allows viewing all program details EXCEPT:   - Sub-licensed Fee Percentage.   - View Invoice button on the students table.   - Drop button on the students table. - **Program/view** allows viewing all program details, including the excluded details above for parentRestrictedView. - **Program/edit** allows viewing the edit program button.
   * Fetch an existing program.
   */
  async fetchProgram(requestParameters: FetchProgramRequest): Promise<Program> {
    const response = await this.fetchProgramRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Fetch possible communities that the requester can view for creating/editing a program.  This is the initial set of options provided when creating or editing a program.  - Returned communities will include any community the requester can view.   - Each community will include a list of all fee settings and the default semester one and semester two start dates.  ## PERMISSIONS: - Requester must possess a Community/view else a 403 will be returned. - Community/view[any] grant allows the requester to see any community, regardless of team.
   * Fetch possible communities for creating/editing a program.
   */
  async fetchProgramOptionsRaw(
    requestParameters: runtime.BaseRequestParameters
  ): Promise<runtime.ApiResponse<ProgramOptions>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs/options`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProgramOptionsFromJSON(jsonValue)
    )
  }

  /**
   *  Fetch possible communities that the requester can view for creating/editing a program.  This is the initial set of options provided when creating or editing a program.  - Returned communities will include any community the requester can view.   - Each community will include a list of all fee settings and the default semester one and semester two start dates.  ## PERMISSIONS: - Requester must possess a Community/view else a 403 will be returned. - Community/view[any] grant allows the requester to see any community, regardless of team.
   * Fetch possible communities for creating/editing a program.
   */
  async fetchProgramOptions(
    requestParameters: runtime.BaseRequestParameters
  ): Promise<ProgramOptions> {
    const response = await this.fetchProgramOptionsRaw(requestParameters)
    return await response.value()
  }

  /**
   * Fetch the program\'s actively enrolled students, and the students\' assigned tutors (if they have an assigned tutor).  ## PERMISSIONS: - When the requester has no permissions, they will only be able to view the students enrolled where they have a student actively enrolled in. - The director or tutor of a program should be able to view the program\'s details regardless of their current grants. While a director/tutor is highly likely to have a Program/view grant, it is not enforced. - **Program/view[their team\'s]** grant allows the requester to view the details of a program where a member of the requester\'s downline team actively directs or tutors the program. - **Program/view[any]** grant allows the requester to see the details of any program, regardless of their team hierarchy.
   * Fetch the program\'s actively enrolled students.
   */
  async fetchStudentsRaw(
    requestParameters: FetchStudentsRequest
  ): Promise<runtime.ApiResponse<ProgramStudentsResponse>> {
    if (
      requestParameters.programId === null ||
      requestParameters.programId === undefined
    ) {
      throw new runtime.RequiredError(
        'programId',
        'Required parameter requestParameters.programId was null or undefined when calling fetchStudents.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs/{programId}/students`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(requestParameters.programId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProgramStudentsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch the program\'s actively enrolled students, and the students\' assigned tutors (if they have an assigned tutor).  ## PERMISSIONS: - When the requester has no permissions, they will only be able to view the students enrolled where they have a student actively enrolled in. - The director or tutor of a program should be able to view the program\'s details regardless of their current grants. While a director/tutor is highly likely to have a Program/view grant, it is not enforced. - **Program/view[their team\'s]** grant allows the requester to view the details of a program where a member of the requester\'s downline team actively directs or tutors the program. - **Program/view[any]** grant allows the requester to see the details of any program, regardless of their team hierarchy.
   * Fetch the program\'s actively enrolled students.
   */
  async fetchStudents(
    requestParameters: FetchStudentsRequest
  ): Promise<ProgramStudentsResponse> {
    const response = await this.fetchStudentsRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Update an existing Program within a community. A program\'s type cannot be updated after initial creation.  - The specified program must be viewable AND editable to the requester, else a 404 will be returned. - The specified community to change to must be viewable to the requester, else a 400 will be returned. - The specified director must:   - possess Program/view, Program/edit, and Program/direct<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified community\'s manager.   - be able to direct a program with the specified Program Type, determined by the director\'s Program/direct<ProgramType> grant. For example, a director with a Program/directFoundations grant can direct a program with the Foundations type. - The specified tutor must:   - possess Program/view and Program/tutor<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified program director.   - be able to tutor a program with the specified Program Type, determined by the tutor\'s Program/tutor<ProgramType> grant. For example, a director with a Program/tutorFoundations grant can tutor a program with the Foundations type. - To update a program status to archive a user must have grant \'archive\'.  ## PERMISSIONS: - Requester must possess a User/view, Community/view, Program/view and Program/edit grant else a 403 will be returned. - Program/view[their team\'s] AND Program/edit[their team\'s] grants allows the requester to edit a program that they direct or their downline team directs. - Program/view[any] AND Program/edit[any] grants allows the requester to edit any program in the system.   - If either Program/view OR Program/edit is scoped as [their team\'s], then editable programs are restricted to the requester\'s team. - User/view[their team\'s] grant allows the requester to assign possible directors and tutors that are within their downline team. - User/view[any] grant allows the requester to assign any possible director or tutor, regardless of team.   - The director must still be in the downline of the community\'s manager.   - The tutor must still be in the downline of the specified director. - Community/view[their team\'s] grant allows the requester to see communities that are within their downline team. - Community/view[any] grant allows the requester to see any community, regardless of team.   - Program/create[their team\'s] will still restrict program community editing to only communities within the requester\'s team. - Program/archive[Any] grant allows to set program status to archive.
   * Update an existing Program.
   */
  async updateProgramRaw(
    requestParameters: UpdateProgramRequest
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: ProgramUpdateToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  Update an existing Program within a community. A program\'s type cannot be updated after initial creation.  - The specified program must be viewable AND editable to the requester, else a 404 will be returned. - The specified community to change to must be viewable to the requester, else a 400 will be returned. - The specified director must:   - possess Program/view, Program/edit, and Program/direct<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified community\'s manager.   - be able to direct a program with the specified Program Type, determined by the director\'s Program/direct<ProgramType> grant. For example, a director with a Program/directFoundations grant can direct a program with the Foundations type. - The specified tutor must:   - possess Program/view and Program/tutor<ProgramType> grants.   - be valid, or will be valid at the time the program starts.   - be within the downline team of the specified program director.   - be able to tutor a program with the specified Program Type, determined by the tutor\'s Program/tutor<ProgramType> grant. For example, a director with a Program/tutorFoundations grant can tutor a program with the Foundations type. - To update a program status to archive a user must have grant \'archive\'.  ## PERMISSIONS: - Requester must possess a User/view, Community/view, Program/view and Program/edit grant else a 403 will be returned. - Program/view[their team\'s] AND Program/edit[their team\'s] grants allows the requester to edit a program that they direct or their downline team directs. - Program/view[any] AND Program/edit[any] grants allows the requester to edit any program in the system.   - If either Program/view OR Program/edit is scoped as [their team\'s], then editable programs are restricted to the requester\'s team. - User/view[their team\'s] grant allows the requester to assign possible directors and tutors that are within their downline team. - User/view[any] grant allows the requester to assign any possible director or tutor, regardless of team.   - The director must still be in the downline of the community\'s manager.   - The tutor must still be in the downline of the specified director. - Community/view[their team\'s] grant allows the requester to see communities that are within their downline team. - Community/view[any] grant allows the requester to see any community, regardless of team.   - Program/create[their team\'s] will still restrict program community editing to only communities within the requester\'s team. - Program/archive[Any] grant allows to set program status to archive.
   * Update an existing Program.
   */
  async updateProgram(requestParameters: UpdateProgramRequest): Promise<void> {
    await this.updateProgramRaw(requestParameters)
  }

  /**
   * Update student-tutor assignments within a program.      - The specified program must be viewable AND editable to the requester, else a 403 will be returned.   - If the specified program is not found, a 404 will be returned.   - Each student being updated must possess an enrollment status in the program as actively enrolled (ENROLLED, MEMBER_HALF, MEMBER_FULL).     Else, a 400 will be returned with a list of error objects for each student not actively enrolled.   - If the request contains at least one invalid pair [studentKey, tutorActorKey], where the student or tutor does not exist, or does not belong to the given program,     no update is performed, and the response will return a 400 with a list or errors of the students and/or tutors that failed validation.   - Each actorTutorKey provided in the request must be present in the Actor table with the validNow field as true. Else, if at least one actorTutorKey does not     meet those requirements, a 400 is returned with a list of error objects of each actorTutorKey that failed validation.   - Each actorTutorKey provided in the request must be assigned to the current program. Else, a 400 is returned with a list of error objects for each actorTutorKey     that did not belong to the program (programId) provided in the request.   - If above validations succeed, then the student-tutor assignments are recorded in the Enrollment table.   - If the update succeeds, a 204 is returned. If the update fails, a 500 InternalServerError is returned.    ## PERMISSIONS:   - Requester must possess a User/view, Program/view, and either Program/edit or Program/create grants, else a 403 will be returned.    - Program/view[any] AND Program/edit[any] grants allows the requester to edit any program in the system.   - If either Program/view OR Program/edit is scoped as [their team\'s], then editable programs are restricted to the requester\'s team.
   * Updates students with a tutor within a program.
   */
  async updateStudentTutorAssignmentsRaw(
    requestParameters: UpdateStudentTutorAssignmentsRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.programId === null ||
      requestParameters.programId === undefined
    ) {
      throw new runtime.RequiredError(
        'programId',
        'Required parameter requestParameters.programId was null or undefined when calling updateStudentTutorAssignments.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/programs/{programId}/studentTutorAssignments`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(requestParameters.programId))
      ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: StudentTutorAssignmentRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Update student-tutor assignments within a program.      - The specified program must be viewable AND editable to the requester, else a 403 will be returned.   - If the specified program is not found, a 404 will be returned.   - Each student being updated must possess an enrollment status in the program as actively enrolled (ENROLLED, MEMBER_HALF, MEMBER_FULL).     Else, a 400 will be returned with a list of error objects for each student not actively enrolled.   - If the request contains at least one invalid pair [studentKey, tutorActorKey], where the student or tutor does not exist, or does not belong to the given program,     no update is performed, and the response will return a 400 with a list or errors of the students and/or tutors that failed validation.   - Each actorTutorKey provided in the request must be present in the Actor table with the validNow field as true. Else, if at least one actorTutorKey does not     meet those requirements, a 400 is returned with a list of error objects of each actorTutorKey that failed validation.   - Each actorTutorKey provided in the request must be assigned to the current program. Else, a 400 is returned with a list of error objects for each actorTutorKey     that did not belong to the program (programId) provided in the request.   - If above validations succeed, then the student-tutor assignments are recorded in the Enrollment table.   - If the update succeeds, a 204 is returned. If the update fails, a 500 InternalServerError is returned.    ## PERMISSIONS:   - Requester must possess a User/view, Program/view, and either Program/edit or Program/create grants, else a 403 will be returned.    - Program/view[any] AND Program/edit[any] grants allows the requester to edit any program in the system.   - If either Program/view OR Program/edit is scoped as [their team\'s], then editable programs are restricted to the requester\'s team.
   * Updates students with a tutor within a program.
   */
  async updateStudentTutorAssignments(
    requestParameters: UpdateStudentTutorAssignmentsRequest
  ): Promise<void> {
    await this.updateStudentTutorAssignmentsRaw(requestParameters)
  }
}
